import React from 'react'
import { hasAvailableAction } from '../../../ui/gov-actions'

const available = (record) => hasAvailableAction(record, 'migrate_to_xplor')

const apiEndPoint = ({ type, type_id }) =>
  process.env.REACT_APP_API_HOST + `/api/${type}s/${type_id}/migrate-to-xplor`

// eslint-disable-next-line react/display-name
const form = ({ name }) => () => (
  <fieldset>Once migrated, Xplor will be responsible for all CCMS submissions for {name}</fieldset>
)

const migrateToXplor = ({ record }) =>
  available(record)
    ? {
      label: 'Migrate all children to Xplor',
      value: 'migrate_xplor',
      component: form(record),
      url: apiEndPoint(record),
    }
    : null

export default migrateToXplor



// WEBPACK FOOTER //
// ./src/gov-registrations/details/gov-actions/migrate-to-xplor.js